<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title eng="TERMS OF SALE" :jpn="t('特定商取引法に基づく表記')" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('販売業者')"
        >
          <div class="text-container">
            <span class="text">{{t('株式会社Iranoan')}}</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('代表責任者')"
        >
          <div class="text-container">
            <span class="text">{{t('鈴木 直')}}</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('会社登記住所・営業所住所')"
        >
          <div class="text-container">
            <span class="text">〒330-0802</span>
            <span class="text">埼玉県さいたま市大宮区宮町1-114-1 ORE大宮ビル5F</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('電話番号')"
        >
          <div class="text-container">
            <span class="text">{{t('048-700-7040')}}</span>
            <span class="text" v-if="i18n_mode=='jp'">(※受付時間 : 平日10時-17時)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('メールアドレス')"
        >
          <div class="text-container">
            <!-- <span class="text">{{t('gacha24@iranoan.com')}}</span>
            <br> -->
            <span class="text">support@iranoan.com</span>
            <span class="text" v-if="i18n_mode=='jp'">
              ※お問い合わせは
              <a href="https://www.iranoan.com/contacts" target="_blank">minny通販店</a>
              よりお願いいたします。
            </span>
            <span class="text" v-else>
              *For inquiries,
              <a href="https://www.iranoan.com/contacts" target="_blank">please use the "chat" or "inquiry form" of the minny mail order store.</a>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('価格')"
        >
          <div class="text-container">
            <span class="text">{{t('各商品毎に表示')}}</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('商品代金以外の必要料金')"
        >
          <div class="text-container left">
            <span class="text">
              {{t('当社の提供するサービスを利用するための機器に関する費用、インターネット接続料金、パケット通信料、消費税、代金支払いの振込手数料')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('引渡時期')"
        >
          <div class="text-container">
            <span class="text">{{t('申込受付時')}}</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('販売数量')"
        >
          <div class="text-container left">
            <span class="text">{{t('特に指定はございません。')}}</span>
            <span class="text">{{t('※商品によって数量制限設定あるものもございます。')}}</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('お支払い方法')"
        >
          <div class="text-container left" v-if="i18n_mode!='jp'">
            <span class="text">
              【For overseas】<br>Credit card, PayPal
            </span>
            <br>
            <span class="text">
              【For Japan】<br>
              Credit card, PayPal , Convenience store ,  Bank Transfer, Carrier Billing, PayPay, LINEPay, Merpay.<br>
              *Please note that we cannot accept cancellations due to customers incidentally after payment has been made.<br>
              <br>
              If you choose bank transfer, please transfer the amount to our account below within 3 days.<br>
              If payment is not made by the deadline, it will be automatically canceled.<br>
              Carrier Billing, PayPay, LINEPay, Merpay can be purchased on the minny website.<br>
              <br>
              [Sumishin SBI Net Bank]<br>
              Corporate First Branch (106)<br>
              usually<br>
              1678946<br>
              f) Iranian<br>
            </span>
          </div>
          <div class="text-container left" v-if="i18n_mode=='jp'">
            <span class="text">
              {{t('クレジットカード・コンビニエンスストア・PayPal・キャリア決済・PayPay・メルペイ・AmazonPayとなります。')}}
            </span>
            <span class="text">
              {{t('※ご決済後のお客様都合によるキャンセルは承ることができません。予めご容赦ください。')}}
            </span>
            <span class="text">
              {{t('期限までにお支払いがない場合、自動的にキャンセルとなります。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('支払時期')"
        >
          <div class="text-container">
            <table class="code">
              <tr>
                <th>{{t('クレジットカード')}}</th>
                <td>{{t('クレジットカード会社の規約に基づく。')}}</td>
              </tr>
              <tr>
                <th>{{t('コンビニ決済')}}</th>
                <td>{{t('ご注文日から３日以内に代金をお支払いください。')}}<br>{{t('期限までにお支払いがない場合、自動的に注文キャンセルとなります。')}}</td>
              </tr>
              <tr>
                <th>{{t('PayPal')}}</th>
                <td>{{t('PayPalの規約に基づく。')}}</td>
              </tr>
              <tr>
                <th>{{t('キャリア決済')}}</th>
                <td>{{t('各キャリアの規約に基づく。')}}</td>
              </tr>
              <tr>
                <th>{{t('PayPay')}}</th>
                <td>{{t('PayPayの規約に基づく。')}}</td>
              </tr>
              <tr>
                <th>{{t('メルペイ')}}</th>
                <td>{{t('メルペイの規約に基づく。')}}</td>
              </tr>
              <tr>
                <th>{{t('AmazonPay')}}</th>
                <td>{{t('AmazonPayの規約に基づく。')}}</td>
              </tr>
            </table>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('返品特約と期限')"
        >
          <div class="text-container left">
            <span class="text">
              {{t('返品・返還不可')}}
            </span>
            <span class="text">
              {{t('利用規約第22条記載のとおり、返品・返還やその他の保証は一切致しません。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('許認可・資格')"
        >
          <div class="text-container">
            <span class="text">{{t('古物商営業許可')}}</span>
            <span class="text">{{t('第431370040346')}}</span>
            <span class="text">{{t('株式会社Iranoan')}}</span>
            <span class="text">{{t('埼玉県公安委員会')}}</span>
          </div>
        </ShadowBoxTitleDescription>

        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="Notation of specials"
        >
          <div class="text-container">
            <span class="text">For products with special price notation, there is a tendency to have "damage is stronger" when compared to the card condition specified by our Company.</span>
            <span class="text">The number of Point exchanges is also lowered and enclosed according to the degree of damage.</span>
            <span class="text">However, cards with severe damage (broken, peeling off, rolled up) will not be enclosed.</span>
            <span class="text">In addition, it does not mean that a card without a special price notation is a perfect product, so please understand so that there is no mistake.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About unopened pack products"
        >
          <div class="text-container">
            <span class="text">Due to the nature of unopened packs, some products cannot check the condition of the contents. In that case, please understand that we cannot guarantee the status of the card.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About Point exchange"
        >
          <div class="text-container">
            <span class="text">For products that do not have a special price, the number of Points at the time of exchange, regardless of whether there are any scratches or not, will be exchanged at full price without any reduction.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About the wrong frame"
        >
          <div class="text-container">
            <span class="text">Since many cards with the same name are enclosed, multiple cards with the same name may be ejected when you purchase multiple units.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About the hidden hits"
        >
          <div class="text-container">
            <span class="text">Almost all of our products have a winning frame other than the image display. </span>
            <span class="text">※Excluding lucky bags and all public products.</span>
            <span class="text">It is not uncommon to cherish the joy and surprise when unexpected winning slots are discharged and each image on the system called Random Discharge Lotto comes out immediately after the sale.</span>
            <span class="text">Even if it is sent on SNS etc. before it is sold out, we have only released a part of the winning frame so that you can play with fun until the end.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About the card status"
        >
          <div class="text-container">
            <span class="text">Since it is a second-hand product, please understand that it is not a perfect product.</span>
            <span class="text">We are careful not to enclose cards with severe damage (folded, rolled up, torn), but please understand that there is a possibility that cards with white hanging, line scratches, scratches, rubbing, etc. will be mixed. Thank you for your purchase.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About Asian and overseas editions"
        >
          <div class="text-container">
            <span class="text">Compared to the Japanese version, there is a tendency to have more detailed threads and white moss.</span>
            <span class="text">In addition, many scratches stand out compared to the Japanese version to the degree of scratches.</span>
            <span class="text">Thank you for your understanding.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="About the initial card"
        >
          <div class="text-container">
            <span class="text">Based on our standards, we have not reduced the amount with some frames Kira, etc., which can be seen in the initial card.</span>
            <span class="text">In addition, I tried to enclose the cards discharged from this lotto as beautifully as possible, but the condition will be uniformly damaged.</span>
            <span class="text">This product is not recommended if you do not understand because it is a card from more than 20 years ago.</span>
            <span class="text">Cards with severe damage are not enclosed. (Breaks, peeling, etc.)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="In the event of a discrepancy between the displayed product image and the product name"
        >
          <div class="text-container">
            <span class="text">This system is a connection between the product name and the reduction point. In the unlikely event that the image does not match the product name, please note that we will give priority to the displayed product name and return points, not the product in the image.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          v-if="i18n_mode!='jp'"
          title="Returns and exchanges of products"
        >
          <div class="text-container">
            <span class="text">Basically, the way you feel the state of the card varies from person to person.</span>
            <span class="text">We have stated that it is a uniform used product and is not a perfect product, so we cannot return or exchange it at all.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  color: #4a3f3a;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
      // color: $white;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 360px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          // color: $white;
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 620px;
  th, td {
    font-size: 13px;
    // color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  table.code {
    width: 100%;
    th, td {
      display: block;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
